import ApplicationConst from "./ApplicationConst";
import { dispatch } from "redux";
import RequestEntity from "./api/RequestEntity";
import BaseURL from "./api/BaseURL";

const BASE_URL = BaseURL.getBaseURL();
const AppActions = {
  loadLanguagePackage:(language) => {
    return {type: ApplicationConst.AJAX_CALL, entity: new RequestEntity("/s/" + language + ".json", "GET", ApplicationConst.GET_LANGUAGE_PACKAGE)}
  },

  switchLanguage:(language) => {
    return {type:ApplicationConst.SWITCH_LANGUAGE, payload:{language: language}};
    //return (dispatch, getState) => {
    //  dispatch({type:ApplicationConst.AJAX_CALL, entity: new RequestEntity("http://localhost:3000/" + language + ".json", "GET", ApplicationConst.GET_LANGUAGE_PACKAGE)});
    //  dispatch({type:ApplicationConst.SWITCH_LANGUAGE, payload:{language: language}})
    //}
  },
  goBack: () => {
    return getState => {
      return getState.history.goBack()
    }
  },
  setToken:(token) => {
    return {type:ApplicationConst.SET_TOKEN, payload: {token:token}}
  }
};
export default AppActions;



// WEBPACK FOOTER //
// ./src/AppActions.js